import { useEffect, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import {
  DISABLE_CAPTCHA,
  RECAPTCHA_SITE_KEY,
  LOCAL_CAPTCHA_TOKEN,
} from "../config/config";

const CaptchaField = ({ onChange, className, style, wrapperStyle }) => {
  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    if (DISABLE_CAPTCHA) {
      onChangeRef.current(LOCAL_CAPTCHA_TOKEN);
    }
  }, []);

  if (DISABLE_CAPTCHA) {
    return null;
  }

  return (
    <div className={className} style={wrapperStyle}>
      <ReCAPTCHA
        sitekey={RECAPTCHA_SITE_KEY}
        onChange={onChange}
        style={style}
      />
    </div>
  );
};

export default CaptchaField;
